import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0bd9e261")

_pushScopeId("data-v-0bd9e261")
const _hoisted_1 = { class: "p-grid p-m-1" }
const _hoisted_2 = { class: "p-col" }
const _hoisted_3 = { class: "p-d-flex p-jc-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createVNode("a", { href: "https://www.knowage-suite.com" }, "Knowage Suite", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_t = _resolveDirective("t")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "kn-dialog--toolbar--primary",
    visible: _ctx.visibility,
    footer: "footer",
    header: _ctx.$t('infoDialog.aboutKnowage'),
    closable: false,
    modal: ""
  }, {
    footer: _withId(() => [
      _withDirectives(_createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.closeDialog
      }, null, 8, ["onClick"]), [
        [_directive_t, 'common.close']
      ])
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("img", {
              src: require('@/assets/images/commons/logo_knowage.svg'),
              height: "100"
            }, null, 8, ["src"])
          ]),
          (!_ctx.configurations || !_ctx.configurations['KNOWAGE.HIDE_VERSION'])
            ? (_openBlock(), _createBlock("p", _hoisted_4, [
                _createVNode("strong", null, _toDisplayString(_ctx.$t("common.version")) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.currentVersion), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode("p", null, [
            _createVNode("strong", null, _toDisplayString(_ctx.$t("common.loggedUser")) + ":", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.user.fullName), 1)
          ]),
          _createVNode("p", null, [
            _createVNode("strong", null, _toDisplayString(_ctx.$t("common.tenant")) + ":", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.user.organization), 1)
          ]),
          _createVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("infoDialog.sourceCode")) + " ", 1),
            _hoisted_5
          ]),
          _createVNode("p", null, _toDisplayString(_ctx.$t("infoDialog.copyright", { year: _ctx.currentYear })), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "header"]))
})